import React from 'react';
import videojs from 'video.js';

import SubscriptionModal from '../generalComponents/SubscriptionModal';

import '../../css/player.css';
import vttThumbnails from 'videojs-vtt-thumbnails/src/plugin.js';
import FeaturedClipControls from './FeaturedClipControls';
import FeaturedSignUpCTA from '../../assets/NakedNewsLive/featured-signup.jpg';
import PlayButton from './PlayButton';

const RESET_CALL_TO_ACTION_IMAGE_AFTER_TIME_IN_MILLIS = 5000;


class SimpleVideoPlayer extends React.Component {

  state = {
    showSubscriptionModal: false,
    isMuted: true,
    isPlaying: false,
    timerId: null,
  };

  playButton = () => {
    if (this.player) {
      this.setState({ isPlaying: true });
      this.player.play();
    }
  };

  stopPlayer = () => {
    const { isFeaturedClip, clip } = this.props;
    if (this.player && isFeaturedClip && this.state.isPlaying) {
      this.player.pause();
      this.setState({ isPlaying: false });
      this.player.poster(clip?.imageUrl);
      this.player.src(clip?.clipUrl);
    }
  };

  onHandleMute = (e) => {
    e.preventDefault();
    this.setState({ isMuted: !this.state.isMuted });
    this.player.muted(!this.state.isMuted);
  };

  initVideoJs = () => {
    const { clip, user, fanZoneFreeVideo, isFeaturedClip } = this.props;
    videojs.registerPlugin('vttThumbnails', vttThumbnails);
    // instantiate Video.js
    this.player = videojs(this.videoNode, this.props, function onPlayerReady() {
      const clipUrls = clip.clipUrls || {};
      this.src(clipUrls.SIZE_720 ||
        clipUrls.SIZE_480 ||
        clipUrls.SIZE_360 ||
        clip.videoUrl ||
        clip.clipUrl);
    });
    if (clip.vtt) {
      this.player.vttThumbnails({
        src: clip.vtt.SRC,
        sprite: clip.vtt.SPRITE,
      });
      const img1 = document.createElement('img');
      img1.src = clip.vtt.SPRITE; // Assigning the img src immediately requests the image
    }
    this.player.on('ended', () => {
      this.setState({ isPlaying: false });
      if (!user?.authenticated && !fanZoneFreeVideo && !isFeaturedClip) {
        this.openSubscriptionModal();
      }
      if (!user?.authenticated && !fanZoneFreeVideo && isFeaturedClip) {
        this.player.poster(FeaturedSignUpCTA);
        const timer = setTimeout(() => {
          this.player.poster(clip?.imageUrl);
        }, RESET_CALL_TO_ACTION_IMAGE_AFTER_TIME_IN_MILLIS);
        this.setState({ timerId: timer });
        this.player.src(clip?.clipUrl);
      }
    });
  };

  componentDidMount() {
    this.initVideoJs();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.clip.videoUrl !== this.props.clip.videoUrl) {
      this.initVideoJs();
    }
  }

  // destroy player on unmount
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }

    if (this.state.timerId) {
      clearTimeout(this.state.timerId);
    }
  }

  openSubscriptionModal = () => {
    this.setState({ showSubscriptionModal: true });
  };

  closeSubscriptionModal = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.setState({ showSubscriptionModal: false });
  };

  handleMouseEnter = () => {
    if (this.props.isFeaturedClip) {
      this.playButton();
    }
  };

  onTogglePlay = (e) => {
    const { isPlaying } = this.state;
    e.preventDefault();
    if (!isPlaying) {
      this.setState({ isPlaying: true });
      this.player.play();
      return;
    }
    if (isPlaying) {
      this.setState({ isPlaying: false });
      this.player.pause();
      return;
    }
  };

  render() {
    const { clip, autoPlayVideo, videoClass = false, isFeaturedClip } = this.props;
    const { showSubscriptionModal, isMuted, isPlaying } = this.state;

    return (
      <>
        <div
          className="masthead"
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.stopPlayer}
        >
          <FeaturedClipControls
            isFeaturedClip={isFeaturedClip}
            isMuted={isMuted}
            isPlaying={isPlaying}
            onMute={this.onHandleMute}
            onTogglePlay={this.onTogglePlay}
          />
          <PlayButton isFeaturedClip={isFeaturedClip} isPlaying={isPlaying} onTogglePlay={this.onTogglePlay} />
          <div className="container">
            <div className="clearfix video-player-container preview" id="video-player-container">
              <div className="full-player">
                <div className="player-zone">
                  <div className="video-player">
                    <div id="vp_18">
                      <div className={`sk-video-player news-player ${videoClass ? 'video-player-trending-page' : null}`} id="vp_18_wrapper">
                        <video
                          ref={(node) => this.videoNode = node}
                          autoPlay={autoPlayVideo}
                          className="video-js vjs-sk vjs-default-skin vjs-paused vp_18_video-dimensions vjs-fluid vjs-controls-enabled vjs-workinghover vjs-v6 vjs-user-active"
                          controls={!isFeaturedClip}
                          id="vp_18_video_html5_api"
                          playinline=""
                          poster={clip.imageUrl}
                          preload="none"
                          tabIndex="-1"
                          muted={isFeaturedClip}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ fontSize: '14px' }}>
            <SubscriptionModal
              closeModal={this.closeSubscriptionModal}
              show={showSubscriptionModal}
            />
          </div>
        </div>
      </>
    );
  }
}

export default SimpleVideoPlayer;
